function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Camada_1",
  "data-name": "Camada 1",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pfad_418",
  "data-name": "Pfad 418",
  d: "M8,0a8,8,0,1,0,8,8A8.01,8.01,0,0,0,8,0ZM8,14.668A6.667,6.667,0,1,1,14.668,8,6.675,6.675,0,0,1,8,14.668Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_419",
  "data-name": "Pfad 419",
  d: "M586.664,333.33a3.338,3.338,0,0,0-3.334,3.334h1.334a2,2,0,1,1,2,2H586v2.667h1.333v-1.4a3.334,3.334,0,0,0-.667-6.6Z",
  transform: "translate(-578.663 -330.663)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rechteck_450",
  "data-name": "Rechteck 450",
  width: 1.334,
  height: 1.334,
  transform: "translate(7.334 12.001)"
}));

function SvgTooltip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Hint",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.002,
    height: 16.002,
    viewBox: "0 0 16.002 16.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.f2a2141c.svg";
export { ForwardRef as ReactComponent };